import cardPlaceRes from '../assets/sound/card-place.mp3';
import lostRes from '../assets/sound/lost.mp3';
import chatBeepRes from '../assets/sound/chat-beep.mp3';
import warningBeepRes from '../assets/sound/warning-beep-timeup.mp3';
import winnerRes from '../assets/sound/winner.mp3';
import foldRes from '../assets/sound/fold.mp3';
import beepYourTurnRes from '../assets/sound/beep-your-turn.mp3';
import chipsRes from '../assets/sound/chips.mp3';
import twoTapsRes from '../assets/sound/two-taps.mp3';
import newPlayerRes from '../assets/sound/new-player-beep.mp3';

export const cardPlaceAudio = new Audio(cardPlaceRes);
export const lostAudio = new Audio(lostRes);
export const chatAudio = new Audio(chatBeepRes);
export const warningAudio = new Audio(warningBeepRes);
export const winnerAudio = new Audio(winnerRes);
export const foldAudio = new Audio(foldRes);
export const beepAudio = new Audio(beepYourTurnRes);
export const chipsAudio = new Audio(chipsRes);
export const twoTapsAudio = new Audio(twoTapsRes);
export const newPlayerAudio = new Audio(newPlayerRes);
